<div *ngIf="usuarioDemo" mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Histórico de Mediciones</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card *ngIf="usuarioDemo" class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4>Micromedidor de:&nbsp;{{micromedidor.idCliente}}</h4>
			</div>
			<div class="col-md-12">
				<span>Especifique un rango de tiempo en el cual desea generar la grafica.</span>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider>
		<dx-validation-group #targetGroup>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
					<div class="row">
						<div class="col col-sm-12 col-md-6 col-lg-6 mt-3">
							<div class="row">
								<button id="boton" type="submit" class="btn btn-success mt-3"
									(click)="obtenerReporteHoy()"><i class="fal fa-calendar-day"></i>Hoy</button>&nbsp;
								<button type="submit" class="btn btn-success mes-actual mt-3"
									(click)="obtenerReporteMes()"><i
										class="fal fa-calendar-alt"></i>{{mesActual.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success mes-anterior mt-3"
									(click)="obtenerReporteMesAnterior()"><i
										class="fal fa-calendar-alt"></i>{{mesAnterior.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success tres-meses mt-3"
									(click)="obtenerReporteTresMeses()"><i class="fas fa-calendar-minus"></i>3
									Meses</button>&nbsp;
								<button type="submit" class="btn btn-success anio mt-3" (click)="obteneReporteAnio()"><i
										class="fal fa-calendar"></i>{{anio}}</button>&nbsp;
							</div>
						</div>
						<div class="col col-sm-12 col-md-6 col-lg-6">
							<div class="row">
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Inicial:</label>
									<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Final:</label>
									<dx-date-box [(value)]="fechaFin" style="width: 100%;" type="datetime"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4 mt-3">
									<button id="boton" type="submit" class="btn btn-success mt-3"
										(click)="obtenerHistorico(fechaInicio, fechaFin, 'rango')"><i
											class="fal fa-search"></i>Buscar</button>&nbsp;
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div id="grafica" class="row mt-3" *ngIf="showGrafica">
			<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-tab-panel #tabPanel class="mt-3" [dataSource]="longtabs" [selectedIndex]="0" [loop]="false"
					[animationEnabled]="true" [swipeEnabled]="true">
					<div *dxTemplate="let grafica of 'title'">
						<span>{{grafica.titulo}}</span>
					</div>
					<div *dxTemplate="let grafica of 'item'">
						<div *ngIf="grafica.titulo === 'Volumen'" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
							<div class="col col-sm-12 col-md-12 col-lg-12">
								<div class="row mt-3">
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Lectura inicial</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenInicial}} Litros</span>&nbsp;&nbsp;
												<span>{{fechaInicial}}</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Volumen Promedio</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenPromedio}} Litros</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="card-info-title">
											<span>Lectura final</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenFinal}} Litros</span>&nbsp;&nbsp;
												<span>{{fechaFinal}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<dx-chart class="mt-3" [dataSource]="mediciones">
								<dxi-series argumentField="fhRegistro" valueField="contador" name="Contador" type="bar"
									color="#01a8fe">
								</dxi-series>
								<dxi-value-axis>
									<dxo-label [customizeText]="valueItems"></dxo-label>
								</dxi-value-axis>
								<dxo-tooltip [enabled]="true" [customizeTooltip]="etiquetaModificada" container="#grafica"></dxo-tooltip>
								<dxo-zoom-and-pan argumentAxis="both" valueAxis="pan"></dxo-zoom-and-pan>
							</dx-chart>
						</div>
					</div>
				</dx-tab-panel>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<!-- demo de garzas grafica -->
<div *ngIf="!usuarioDemo" mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Histórico de Garzas</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card *ngIf="!usuarioDemo" class="mt-2">
	<!-- <mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4>Micromedidor de:&nbsp;{{micromedidor.idCliente}}</h4>
			</div>
			<div class="col-md-12">
				<span>Especifique un rango de tiempo en el cual desea generar la grafica.</span>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider>
		<dx-validation-group #targetGroup>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
					<div class="row">
						<div class="col col-sm-12 col-md-6 col-lg-6 mt-3">
							<div class="row">
								<button id="boton" type="submit" class="btn btn-success mt-3"
									(click)="obtenerReporteHoy()"><i class="fal fa-calendar-day"></i>Hoy</button>&nbsp;
								<button type="submit" class="btn btn-success mes-actual mt-3"
									(click)="obtenerReporteMes()"><i
										class="fal fa-calendar-alt"></i>{{mesActual.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success mes-anterior mt-3"
									(click)="obtenerReporteMesAnterior()"><i
										class="fal fa-calendar-alt"></i>{{mesAnterior.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success tres-meses mt-3"
									(click)="obtenerReporteTresMeses()"><i class="fas fa-calendar-minus"></i>3
									Meses</button>&nbsp;
								<button type="submit" class="btn btn-success anio mt-3" (click)="obteneReporteAnio()"><i
										class="fal fa-calendar"></i>{{anio}}</button>&nbsp;
							</div>
						</div>
						<div class="col col-sm-12 col-md-6 col-lg-6">
							<div class="row">
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Inicial:</label>
									<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Final:</label>
									<dx-date-box [(value)]="fechaFin" style="width: 100%;" type="datetime"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4 mt-3">
									<button id="boton" type="submit" class="btn btn-success mt-3"
										(click)="obtenerHistorico(fechaInicio, fechaFin, 'rango')"><i
											class="fal fa-search"></i>Buscar</button>&nbsp;
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div id="grafica" class="row mt-3" *ngIf="showGrafica">
			<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-tab-panel #tabPanel class="mt-3" [dataSource]="longtabs" [selectedIndex]="0" [loop]="false"
					[animationEnabled]="true" [swipeEnabled]="true">
					<div *dxTemplate="let grafica of 'title'">
						<span>{{grafica.titulo}}</span>
					</div>
					<div *dxTemplate="let grafica of 'item'">
						<div *ngIf="grafica.titulo === 'Volumen'" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
							<div class="col col-sm-12 col-md-12 col-lg-12">
								<div class="row mt-3">
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Lectura inicial</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenInicial}} Litros</span>&nbsp;&nbsp;
												<span>{{fechaInicial}}</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Volumen Promedio</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenPromedio}} Litros</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="card-info-title">
											<span>Lectura final</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{volumenFinal}} Litros</span>&nbsp;&nbsp;
												<span>{{fechaFinal}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<dx-chart class="mt-3" [dataSource]="mediciones">
								<dxi-series argumentField="fhRegistro" valueField="contador" name="Contador" type="bar"
									color="#01a8fe">
								</dxi-series>
								<dxi-value-axis>
									<dxo-label [customizeText]="valueItems"></dxo-label>
								</dxi-value-axis>
								<dxo-tooltip [enabled]="true" [customizeTooltip]="etiquetaModificada" container="#grafica"></dxo-tooltip>
								<dxo-zoom-and-pan argumentAxis="both" valueAxis="pan"></dxo-zoom-and-pan>
							</dx-chart>
						</div>
					</div>
				</dx-tab-panel>
			</div>
		</div>
	</mat-card-content> -->
	<mat-card-content class="card-contentDemo">
		<div id="grafica" class="row mt-3">
			<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-chart id="chart" [title]="title" [dataSource]="dato">
					<dxi-series valueField="mass" argumentField="name" type="bar"> </dxi-series>
					<dxi-value-axis
					  [visible]="true"
					  [autoBreaksEnabled]="autoBreaksEnabledValue"
					  [maxAutoBreakCount]="breaksCountValue"
					>
					  <dxo-break-style [line]="lineStyleValue"> </dxo-break-style>
					</dxi-value-axis>
					<dxo-legend [visible]="false"> </dxo-legend>
					<dxo-tooltip [enabled]="true"> </dxo-tooltip>
				  </dx-chart>
			</div>
		</div>
		</mat-card-content>
</mat-card>